import { render, staticRenderFns } from "./BookingOverview.vue?vue&type=template&id=48984025"
import script from "./BookingOverview.js?vue&type=script&lang=js&external"
export * from "./BookingOverview.js?vue&type=script&lang=js&external"
import style0 from "./BookingOverview.vue?vue&type=style&index=0&id=48984025&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports